
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking-support",
      function () {
        return require("private-next-pages/booking-support.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/booking-support"])
      });
    }
  